module.exports = __webpack_public_path__ + "img/fi-rr-rectangle-horizontal.51e07891.svg";